
export default "/assets/pencil-square-micro.8640927f.svg"